import React, { useState } from 'react';
import { headerStyled } from 'components/UniversalSearch/components/Header/Header.styled';
import { WorkspaceSelector } from 'components/UniversalSearch/components/WorkspaceSelector/WorkspaceSelector';
import { IconClose } from 'components/Icons/IconClose';
import { IconSearch } from 'components/Icons';
import { useUniversalSearchStore } from 'components/UniversalSearch/UniversalSearchStore';
import { isUrl } from 'utils/url';
import { useDebounce } from 'react-use';
type HeaderProps = {
  onClose: () => void;
};
export const Header: React.FC<HeaderProps> = ({
  onClose
}) => {
  const {
    userOrOrgId,
    updateUserOrOrgId,
    updateSearchParam
  } = useUniversalSearchStore();
  const [searchValue, setSearchValue] = useState<string>('');
  const onChangeSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value || '');
  };
  const setSearchParam = (searchTerm: string) => {
    if (isUrl(searchTerm)) {
      const {
        modelId
      } = extractModelIdsFromUrl(searchTerm);
      if (modelId) return updateSearchParam(modelId);
    }
    return updateSearchParam(searchTerm);
  };
  useDebounce(() => {
    if (searchValue.length) setSearchParam(searchValue);else setSearchParam('');
  }, 350, [searchValue]);
  return <div className={headerStyled}>
      <div className="workspace-selector">
        <WorkspaceSelector currentWorkspaceId={userOrOrgId} onSelectWorkspaceId={currentUserOrOrgId => {
        updateUserOrOrgId(currentUserOrOrgId);
      }} />
      </div>
      <div className="search-input">
        <IconSearch size={20} color="#667085" />
        <input className="input-field" type="text" placeholder="Search resources..." value={searchValue} onChange={onChangeSearchValue} />
      </div>
      <div className="close-icon">
        <IconClose color="#344054" onClick={onClose} />
      </div>
    </div>;
};
const extractModelIdsFromUrl = (url: string): {
  modelId?: string;
  modelVersionId?: string;
} => {
  const regex = /\/models\/([^/]+)(?:\/versions\/([^/]+))?/;
  const match = url.match(regex);
  if (match) {
    const modelId = match[1];
    const modelVersionId = match[2];
    return {
      modelId,
      modelVersionId
    };
  }
  return {
    modelId: undefined,
    modelVersionId: undefined
  };
};